import { render, staticRenderFns } from "./StorageTile.vue?vue&type=template&id=6bc4531b"
import script from "./StorageTile.vue?vue&type=script&lang=js"
export * from "./StorageTile.vue?vue&type=script&lang=js"
import style0 from "./StorageTile.vue?vue&type=style&index=0&id=6bc4531b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports